// Angular
import { Component, Input, OnInit } from '@angular/core';
// Model
import { ResourceModel } from '../model/resource-media.model';
import { ReportImageModel } from '../model/report-image.model';
import { ResourceMediaControlService } from '../service/resource-media-control.service';

@Component({
	selector: 'cv-schema-render-report-image',
	templateUrl: './report-image.component.html',
	providers: [ ResourceMediaControlService ]
})
export class ReportImageComponent implements OnInit {
	@Input() data: any;
	@Input() resourceModel: ResourceModel =  new ResourceModel();

	public reportImage: ReportImageModel = new ReportImageModel();

	// Contiguous Room
	public contiguousRoomsList = [];

	constructor(
		private resourceMediaControlService: ResourceMediaControlService
	) {
	}

	ngOnInit(): void {
		this.populateContiguousRoomsList();
	}

	/**
	 * Get the List of possible rooms to show when creating Report Images
	 * @private
	 */
	private populateContiguousRoomsList(): void {
		const thisRoom = {
			key: this.data._Path,
			label: this.data.cv_Label
		};

		this.contiguousRoomsList = [];
		this.contiguousRoomsList.push(thisRoom);

		const roomsConnected = this.data['_Connections'] || [];

		roomsConnected.forEach(room => {
			const mappedRoom = {
				key: room.path,
				label: room.cv_Label
			};
			this.contiguousRoomsList.push(mappedRoom);
		});

		setTimeout(() => {
			this.onSelectContiguousRoom(thisRoom);
		}, 0);

	}

	/**
	 * Change the Contigous Room
	 * @param event
	 */
	public onSelectContiguousRoom (event: any): void {
		this.reportImage.selectedContiguousRoom = event
		this.resourceModel.reportImage = this.reportImage;

		this.resourceMediaControlService.resourceModelChange.next(this.resourceModel);
	}
}
